export default __webpack_public_path__ + "static/media/Asset-68.73978952.png";